'use client';

import { CloseIcon } from '@c/icons';
import { useConsent } from 'context/ConsentContext';
import Link from 'next/link';
import Button from './Button';

const CookiesAndPrivacy = () => {
  const { hasUserChosen, requiresConsent, acceptAll, acceptNecessaryOnly } =
    useConsent();
  if (hasUserChosen || !requiresConsent) return null;

  return (
    <div className="sticky bottom-4 z-50 ml-auto flex max-w-full flex-col gap-[0.8rem] rounded-brand bg-black p-[1.6rem] font-medium text-white shadow-lg sm:w-[50rem]">
      <div className="flex w-full justify-between">
        <h2>Cookies &amp; Privacy</h2>

        <button type="button" aria-label="Close" onClick={acceptNecessaryOnly}>
          <CloseIcon />
        </button>
      </div>

      <p>
        We use cookies and similar technologies, including those provided by
        third parties, for analytics, advertising, and site functionality. You
        may accept all cookies or limit use to necessary cookies only. See our{' '}
        <Link href="/privacy-policy" className="underline">
          Privacy Policy
        </Link>{' '}
        for details.
      </p>

      <div className="flex gap-x-4">
        <Button type="primary" onClick={acceptNecessaryOnly}>
          Accept Necessary Only
        </Button>

        <Button type="secondary" onClick={acceptAll}>
          Accept
        </Button>
      </div>
    </div>
  );
};

export default CookiesAndPrivacy;
